// import React, { useState } from 'react';
// import styles from './index.module.css';
// import HeaderInvoiceTable from './components/HeaderInvoiceTable';

// const HeaderInvoice = () => {
//   const [activeSection, setActiveSection] = useState('headers');

//   return (
//     <div className={styles.container}>
//       <div className={styles.content}>
//         <div className={styles.sectionTabs}>
//           <button
//             className={`${styles.tabButton} ${activeSection === 'headers' ? styles.tabButtonActive : ''}`}
//             onClick={() => setActiveSection('headers')}
//           >
//             Invoice Headers
//           </button>
//         </div>

//         {activeSection === 'headers' && (
//           <div className={styles.sectionContent}>
//             <HeaderInvoiceTable />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default HeaderInvoice;

import React, { useState } from 'react';
import styles from './index.module.css';
import HeaderInvoiceTable from './components/HeaderInvoiceTable';
import InvoiceDetail from './components/InvoiceDetail';

const HeaderInvoice = () => {
  const [activeSection, setActiveSection] = useState('headers');
  const [selectedInvoiceNum, setSelectedInvoiceNum] = useState(null);
  const [savedTableState, setSavedTableState] = useState({
    currentPage: 0,
    searchTerm: '',
    selectedYear: '',
    selectedMonth: '',
    selectedStatus: '',
    sortBy: '',
    sortOrder: 'desc'
  });

  const handleInvoiceClick = (invoiceNum, tableState) => {
    setSavedTableState(tableState);
    setSelectedInvoiceNum(invoiceNum);
    setActiveSection('detail');
  };

  const handleBackToHeaders = () => {
    setActiveSection('headers');
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.sectionTabs}>
          <button
            className={`${styles.tabButton} ${activeSection === 'headers' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('headers')}
          >
            Invoice Headers
          </button>
          <button
            className={`${styles.tabButton} ${activeSection === 'detail' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('detail')}
          >
            Invoice Detail
          </button>
        </div>

        {activeSection === 'headers' && (
          <div className={styles.sectionContent}>
            <HeaderInvoiceTable
              onInvoiceClick={handleInvoiceClick}
              savedState={savedTableState}
            />
          </div>
        )}

        {activeSection === 'detail' && (
          <div className={styles.sectionContent}>
            <InvoiceDetail
              initialInvoiceNum={selectedInvoiceNum}
              onBack={handleBackToHeaders}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderInvoice;